import { isNativeWebView } from '@/lib/isNativeWebView';

// Snapshot of the device/channel a checkout is happening on, for admin diagnostics.
export function getDeviceContext() {
  const ua = navigator.userAgent || '';
  const isTablet = /iPad|Tablet/i.test(ua);
  const isMobile = /Mobi|Android|iPhone|iPad/i.test(ua);
  const os = /iPhone/i.test(ua) ? 'iPhone' : /iPad/i.test(ua) ? 'iPad' : /Android/i.test(ua) ? 'Android'
    : /Windows/i.test(ua) ? 'Windows' : /Mac OS X/i.test(ua) ? 'Mac' : /Linux/i.test(ua) ? 'Linux' : 'Other';
  const browser = /Edg\//.test(ua) ? 'Edge' : /CriOS|Chrome\//.test(ua) ? 'Chrome' : /FxiOS|Firefox\//.test(ua) ? 'Firefox'
    : /Safari\//.test(ua) ? 'Safari' : 'Other';
  const native = isNativeWebView();
  const channel = native ? (os === 'Android' ? 'android_app' : 'ios_app') : 'browser';
  return {
    device_type: isTablet ? 'tablet' : isMobile ? 'mobile' : 'desktop',
    channel,
    os,
    browser: native ? 'app' : browser,
    screen_width: window.innerWidth,
    label: `${os} · ${native ? 'native app' : browser}`,
  };
}